/**
 * The PasswordReset Form component
 */
import React from 'react';
import { Grid, Typography } from '@mui/material';

import styles from './Maintenance.module.css';
import vpLogo from '../../Assets/images/logo.svg';

export default function Maintenance() {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage:
          "url('https://storage.googleapis.com/fashionnova-public-files/FN_WAREHOUSE-2.jpg')",
      }}
    >
      <div className={styles.containerFlexCenter}>
        <div className={styles.formContainer}>
          <div className={styles.logo}>
            <img src={vpLogo} alt="logo" />
          </div>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ padding: '16px ' }}
          >
            <Typography
              variant="h4"
              style={{ marginTop: '35px' }}
              align="center"
            >
              The portal is currently down for maintenance.
            </Typography>
            <p style={{ marginTop: '35px', textAlign: 'center' }}>
              Please contact{' '}
              <a href="mailto:vendormasterdata@fashionnova.com">
                vendormasterdata@fashionnova.com
              </a>
              or{' '}
              <a href="mailto:influencerdocs@fashionnova.com">
                influencerdocs@fashionnova.com
              </a>
              <br />
              with any urgent requests.
            </p>
          </Grid>
        </div>
      </div>
    </div>
  );
}
